import React from 'react';
import { IconProps } from '@msc-b2c/interfaces/types';
import clsx from 'clsx';
import { handleKeyDown } from '@msc-b2c/shared-utils/keyboardUtils';

export const Icon = React.forwardRef<HTMLElement, IconProps>(function Icon(
  { icon, ariaHidden = false, ariaLabel, onClick, styleOption, tooltipTitle, color },
  ref
) {
  const handleKeyDownWrapper = (event: React.KeyboardEvent) => {
    handleKeyDown(event, onClick as (...args: any[]) => void);
  };

  return (
    icon !== 'no-icon' && (
      <i
        ref={ref}
        aria-hidden={ariaHidden}
        aria-label={ariaHidden ? undefined : ariaLabel}
        className={clsx(
          'icon',
          { [`icon-${icon}`]: icon },
          { 'clickable-icon': icon && onClick },
          styleOption
        )}
        onClick={onClick}
        role={onClick && !ariaHidden ? 'button' : undefined}
        tabIndex={onClick && !ariaHidden ? 0 : -1}
        onKeyDown={onClick ? handleKeyDownWrapper : undefined}
        data-testid={`icon - ${ariaLabel || 'default'}`}
        title={tooltipTitle ?? ''}
        style={{ color }}
      ></i>
    )
  );
});
